import { gql } from "@apollo/client";
import { Box, Stack } from "@chakra-ui/react";
import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

import { PageTitle } from "../../components/Page";
import { Panel } from "../../components/Panel";
import { QuoteForm } from "../../components/QuoteForm";
import { buildQuotePagePath, RouteParams } from "../../config/routes";
import { useCreateQuoteMutation } from "../../generated/graphql";
import { useSingleParam } from "../../hooks/useSingleParam";

export const CREATE_QUOTE = gql`
  mutation CreateQuote($input: CreateQuoteInput!) {
    createQuote(input: $input) {
      id
    }
  }
`;

export const QuoteCreationPage = () => {
  const navigate = useNavigate();
  const supplierSlug = useSingleParam(RouteParams.SupplierSlug, { required: true });

  const [createQuote] = useCreateQuoteMutation();

  return (
    <Fragment>
      <Helmet>
        <title>WMS | New Quote</title>
      </Helmet>
      <Stack spacing={6} px={8} py={5}>
        <Stack width="100%" isInline justifyContent="space-between">
          <PageTitle>New Quote</PageTitle>
        </Stack>

        <Panel maxWidth="900px">
          <Box px={8} py={5}>
            <QuoteForm
              onSubmit={async (values) => {
                const { data } = await createQuote({
                  variables: {
                    input: {
                      ...values,
                      supplierSlug,
                    },
                  },
                });

                if (data?.createQuote?.id) {
                  navigate(buildQuotePagePath(supplierSlug, data.createQuote.id));
                  return;
                }

                console.log("TODO: handle this");
              }}
            />
          </Box>
        </Panel>
      </Stack>
    </Fragment>
  );
};
